export const ROLE_ID_SUPER_USER = 1
export const ROLE_ID_ADMIN = 2

export const USER_ACCOUNT_ADMIN = 'admin'

export const ROLE_TYPE = {
    ROOT_ROLE: '0',
    NORMAL_ROLE: '1',
    ADMIN_ROLE: '-1'
}

export const RECOMMENDATION_AUTH_ROOT_ROLE = 'root_role'
export const RecommendationAuthMap = {
    [RECOMMENDATION_AUTH_ROOT_ROLE]: [  // 總代理預設勾選權限
        'member_list.view',
        'member_list.active',
        'member_list.export',
        'member_list.all_members_money',
        'member_search.view',
        'member_search.export',
        'member_login_history.view',
        'member_login_history.export',
        'game_report.view',
        'game_report.export',
        // 'game_report.real_time',
        'settlement_report.view',
        'settlement_report.export',
        'game_round_result.view',
        'game_round_result.export',
        'bet_game_round_result.view',
        'bet_game_round_result.export',
        'user.view',
        'user.add',
        'user.edit',
        'user.active',
        'user.delete',
        'role.view',
        'role.add',
        'role.edit',
        'role.delete',
        'game_list.view',
        'game_list.active',
        // 'game_elastic_max_bet.view',
        'event_prize.view'
    ],
}

export const STANDARD_AUTH = {
    announcement: ['view', 'add', 'edit', 'active', 'delete'],
    marquee: ['view', 'add', 'edit', 'active', 'delete'],
    game_list: ['view', 'active', 'release','exclusive'],
    // game_elastic_max_bet: ['view'],
    member_list: ['view', 'active', 'export', 'all_members_money'],
    member_search: ['view', 'export'],
    member_login_history: ['view', 'export'],
    game_report: ['view', 'export', 'real_time'],
    settlement_report: ['view', 'export'],
    game_round_result: ['view', 'export'],
    bet_game_round_result: ['view', 'export'],
    online_player: ['view'],
    finance_reconciliation: ['view', 'export'],
    event_prize: ['view', 'edit'],
    user: ['view', 'add', 'edit', 'active', 'delete', 'otp', 'reset_pwd', 'otp_active', 'view_peers'],
    role: ['view', 'add', 'edit', 'delete', 'administrator'],
    transfer_record: ['view', 'export'],
    single_wallet: ['view', 'register', 'edit', 'validate'],
    report: ['maker'],
    internal: ['validate']
}

export const SUPER_USER_AUTH = {
    event_management: ['view', 'edit', 'add', 'delete'],
    event_prize: ['view', 'edit'],
    platform: ['view', 'add', 'edit'],
    default_rtp_setting: ['view', 'edit'],
    water_pool: ['view'],
    manual_prize: ['view'],
    player_role_list: ['view'],
    risk_rule_setting: ['view'],
    continuous_loss_setting: ['view'],
    riskmgt_log: ['view'],
    constraint: ['hide_sub_pf_name', 'ignore_search_time_interval_limit'],
    single_wallet: ['view', 'register', 'edit', 'validate'],
    platfrom_game_waterpool: ['view', 'edit'],
    game_ranking_list: ['view', 'rerank', 'edit'],
    new_game_recommend_page: ['view', 'add', 'edit', 'delete'],
    popular_game_recommend_page: ['view', 'add', 'edit', 'delete'],
    activity_image_manage: ['view', 'add', 'edit', 'delete'],
    internal: ['validate']
}
